import { render, staticRenderFns } from "./powerManager.vue?vue&type=template&id=47ad08f9&scoped=true&"
import script from "./powerManager.vue?vue&type=script&lang=js&"
export * from "./powerManager.vue?vue&type=script&lang=js&"
import style1 from "./powerManager.vue?vue&type=style&index=1&id=47ad08f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ad08f9",
  null
  
)

export default component.exports